import type { FC, ReactChild } from 'react';
import React, { useMemo } from 'react';

type RicosDirectionHandledContextProps = {
  directionHandled?: boolean;
  children: ReactChild;
};

type ContextType = {
  directionHandled?: boolean;
};

export const RicosDirectionHandledContext = React.createContext<ContextType>(
  null as unknown as ContextType
);

export const RicosDirectionHandledContextProvider: FC<RicosDirectionHandledContextProps> = ({
  directionHandled,
  children,
}) => {
  const directionHandledValue = useMemo(() => {
    return { directionHandled };
  }, [directionHandled]);
  return (
    <RicosDirectionHandledContext.Provider value={directionHandledValue}>
      {children}
    </RicosDirectionHandledContext.Provider>
  );
};
